var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tabs',{attrs:{"type":"border-card","vs.height":"H-74"},on:{"tab-click":function($event){}},model:{value:(_vm.temp),callback:function ($$v) {_vm.temp=$$v},expression:"temp"}},[_c('el-tab-pane',{attrs:{"label":"普通用户","name":""}}),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"内置用户","name":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59db4ac1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/$MyTabs.vue
// module id = null
// module chunks = 